import React from 'react';
import { Link } from 'react-router-dom';
import { Country } from '../../data/countryData';

interface TopDestinationsProps {
  country: Country;
}

const TopDestinations: React.FC<TopDestinationsProps> = ({ country }) => {

  const TopDestinationCard: React.FC<{ destination: { id: number, name: string, fastFacts: string[], imageUrl: string, slug: string } }> = ({ destination }) => {
    return (
      <Link
        to={`/destinations/${country.slug}/${destination.slug}`}
        className="max-w-sm rounded-lg overflow-hidden shadow-lg bg-white cursor-pointer"
      >
        <div className="relative pb-3/4 h-52 overflow-hidden group">
          <img className="h-full w-full object-cover transform transition-transform duration-300 ease-in-out group-hover:scale-110" src={destination.imageUrl} alt={destination.name} />
        </div>
        <div className="p-4 bg-white">
          <h3 className="text-lg font-semibold mb-2">{destination.name}</h3>
        </div>
      </Link>
    );
  };

  return (
    <div className="px-0 py-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {country.topDestinations.map((destination, index) => (
        <TopDestinationCard key={index} destination={destination} />
      ))}
    </div>
  );
};

export default TopDestinations;
